if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.previousButton = this.querySelector('[data-product-modal-previous]');
        this.nextButton = this.querySelector('[data-product-modal-next]');

        [this.previousButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.previousButton?.addEventListener('click', () => this.showAdjacentMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showAdjacentMedia(1));

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showAdjacentMedia(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showAdjacentMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        delete this.dataset.navigationDirection;
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.activateMedia(activeMedia);
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      showAdjacentMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;

        const activeIndex = mediaItems.findIndex((media) => media.classList.contains('active'));
        const nextIndex = (Math.max(activeIndex, 0) + direction + mediaItems.length) % mediaItems.length;
        this.dataset.navigationDirection = direction > 0 ? 'next' : 'previous';
        this.activateMedia(mediaItems[nextIndex]);
      }

      activateMedia(activeMedia) {
        if (!activeMedia) return;

        pauseAllMedia();
        this.getMediaItems().forEach((element) => element.classList.remove('active'));

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
